import React from 'react';
import BrandLogo from '../BrandLogo';

export default function MarketingFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-white/5 py-12">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="flex flex-col gap-3">
          <BrandLogo variant="footer" />
          <p className="text-xs text-slate-500 font-mono">
            <span className="block">{`Copyright ${year} ComplyTradeIQ. All rights reserved.`}</span>
            <span className="mt-1 block">Disclaimer: This is a prototype and not a real product.</span>
          </p>
        </div>
        <p className="text-sm text-slate-500 max-w-md">
          Advisory platform. Not a customs broker. Validation output requires human review before submission.
        </p>
      </div>
    </footer>
  );
}
